var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_133-right-arrow",
    "data-name": "133-right-arrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10.783,
    viewBox: "0 0 14 10.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(0 4.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M.566,235.318H13.434a.566.566,0,0,1,0,1.131H.566a.566.566,0,0,1,0-1.131Z",
    transform: "translate(0 -235.318)",
    fill: "#868eae"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M294.314,63.821,299.14,59a.566.566,0,0,1,.8.8l-4.426,4.426,4.426,4.426a.566.566,0,1,1-.8.8l-4.826-4.826A.566.566,0,0,1,294.314,63.821Z",
    transform: "translate(-294.148 -58.83)",
    fill: "#868eae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4df8a9e8dee2a812e45cb520f894a3a5.svg";
export { ForwardRef as ReactComponent };